export class Utilities {
  isDev: boolean;

  constructor({ isDev }: { isDev: boolean }) {
    this.isDev = isDev;
  }

  public devLog(log: unknown) {
    if (this.isDev) {
      console.log(log);
    }
  }

  public devWarn(warn: unknown) {
    if (this.isDev) {
      console.warn(warn);
    }
  }

  public devError(error: unknown) {
    if (this.isDev) {
      console.error(error);
    }
  }
}
